import Requests from './requests'

export default class Roles extends Requests {

  list () {
    return this._getMany()
  }

  get (id) {
    return this._getOne(id)
  }

  create (role) {
    return this._create(role)
  }

  update (role) {
    return this._update(role)
  }

  delete (id) {
    return this._delete(id)
  }

}



// WEBPACK FOOTER //
// ./src/roles.js